var _style, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 83 82.26",
    style: {
      enableBackground: "new 0 0 83 82.26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000013911449319291118470000013566016801937069502_);}\r\n\t.st2{fill:url(#SVGID_00000050622240259623495390000010652186865340708252_);}\r\n\t.st3{fill:url(#SVGID_00000054235911275372300650000009703061670554535819_);}\r\n\t.st4{fill:#5CE1E6;}\r\n\t.st5{fill:url(#SVGID_00000129190827409612764980000016632339034625481903_);}\r\n\t.st6{fill:url(#SVGID_00000019662094533046350700000016439679118130156707_);}\r\n\t.st7{fill:url(#SVGID_00000043419276081629889070000005484921867511944877_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.3202,
    y1: 10.8833,
    x2: 78.7515,
    y2: 77.4861
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.16,32.5c0,5.61-4.56,10.18-10.17,10.18c-4.98,0-9.13-3.6-10-8.34h10c1.01,0,1.84-0.82,1.84-1.84V22.49 C30.56,23.35,34.16,27.51,34.16,32.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046335286241237436480000013984983948612607125_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.48,
    y1: 39.3148,
    x2: 82.62,
    y2: 39.3148
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.05
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046335286241237436480000013984983948612607125_)"
    },
    d: "M0.48,7.24v64.15h82.14V7.24H0.48z  M45.79,13.29h29.67c1.01,0,1.83,0.83,1.83,1.84c0,1.02-0.82,1.84-1.83,1.84H45.79c-1.01,0-1.84-0.82-1.84-1.84 C43.95,14.12,44.78,13.29,45.79,13.29z M45.79,20.99h29.67c1.01,0,1.83,0.82,1.83,1.84c0,1.01-0.82,1.84-1.83,1.84H45.79 c-1.01,0-1.84-0.83-1.84-1.84C43.95,21.81,44.78,20.99,45.79,20.99z M4.22,26.83c0-7.56,6.14-13.7,13.68-13.7h0.05 c1.01,0,1.83,0.82,1.83,1.84v11.86c0,1.01-0.82,1.84-1.83,1.84H6.06C5.04,28.67,4.22,27.84,4.22,26.83z M32.55,64.72H6.85 c-1.01,0-1.83-0.82-1.83-1.84c0-1.01,0.82-1.84,1.83-1.84h25.7c1.01,0,1.83,0.83,1.83,1.84C34.38,63.9,33.56,64.72,32.55,64.72z  M32.55,57.03H6.85c-1.01,0-1.83-0.83-1.83-1.84c0-1.02,0.82-1.84,1.83-1.84h25.7c1.01,0,1.83,0.82,1.83,1.84 C34.38,56.2,33.56,57.03,32.55,57.03z M23.99,46.36c-7.63,0-13.84-6.22-13.84-13.86c0-1.01,0.82-1.84,1.84-1.84h10.16V20.48 c0-1.02,0.83-1.84,1.84-1.84c7.63,0,13.84,6.22,13.84,13.86C37.83,40.14,31.62,46.36,23.99,46.36z M75.92,65.13H42.45 c-1.02,0-1.84-0.82-1.84-1.84c0-1.01,0.82-1.84,1.84-1.84h3.78v-6.22c0-1.01,0.82-1.84,1.83-1.84c1.02,0,1.84,0.83,1.84,1.84v6.22 h1.95V47.17c0-1.01,0.82-1.84,1.84-1.84c1.01,0,1.84,0.83,1.84,1.84v14.28h1.95v-8.23c0-1.02,0.82-1.84,1.83-1.84 c1.02,0,1.84,0.82,1.84,1.84v8.23h1.95V49.19c0-1.02,0.83-1.84,1.84-1.84s1.84,0.82,1.84,1.84v12.26h1.95v-4.2 c0-1.02,0.82-1.84,1.84-1.84c1.01,0,1.83,0.82,1.83,1.84v4.2h3.52c1.01,0,1.83,0.83,1.83,1.84C77.75,64.31,76.93,65.13,75.92,65.13z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059282173593440867820000014426527920097334680_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.067,
    y1: -20.4701,
    x2: 99.4354,
    y2: 52.3337
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "url(#SVGID_00000059282173593440867820000014426527920097334680_)"
    },
    width: 83,
    height: 3.48
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101065309495408235200000018004664587693520256_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.8311,
    y1: -8.9865,
    x2: 95.5679,
    y2: 73.0039
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101065309495408235200000018004664587693520256_)"
    },
    d: "M40.34,51.94c0.47,0,0.94-0.18,1.3-0.54 l11.51-11.52l5.82,5.82c0.72,0.72,1.88,0.72,2.6,0l8.38-8.4l1.99,1.99c0.29,0.29,0.68,0.45,1.08,0.45c0.14,0,0.29-0.02,0.43-0.06 c0.54-0.16,0.94-0.6,1.06-1.15l1.81-8.46c0.11-0.51-0.05-1.04-0.41-1.4c-0.37-0.37-0.89-0.52-1.4-0.41l-8.45,1.81 c-0.55,0.12-0.99,0.53-1.15,1.06c-0.16,0.54-0.01,1.12,0.39,1.52l2.05,2.05l-7.09,7.09l-5.82-5.82c-0.72-0.72-1.88-0.72-2.6,0 L39.04,48.8c-0.72,0.72-0.72,1.88,0,2.6C39.4,51.76,39.87,51.94,40.34,51.94z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23.85,80.42c0,1.02-0.82,1.84-1.84,1.84H15.3c-1.01,0-1.84-0.82-1.84-1.84c0-1.01,0.83-1.84,1.84-1.84h6.71 C23.03,78.58,23.85,79.41,23.85,80.42z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M33.63,80.42c0,1.02-0.83,1.84-1.84,1.84h-3.18c-1.01,0-1.83-0.82-1.83-1.84c0-1.01,0.82-1.84,1.83-1.84h3.18 C32.8,78.58,33.63,79.41,33.63,80.42z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M70.96,80.42c0,1.02-0.82,1.84-1.83,1.84H38.75c-1.01,0-1.83-0.82-1.83-1.84c0-1.01,0.82-1.84,1.83-1.84h30.38 C70.14,78.58,70.96,79.41,70.96,80.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015318707846694503090000002730914384716128181_",
    gradientUnits: "userSpaceOnUse",
    x1: -35.7763,
    y1: 33.312,
    x2: 58.9605,
    y2: 115.3024
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000015318707846694503090000002730914384716128181_)"
    },
    d: "M23.85,80.42c0,1.02-0.82,1.84-1.84,1.84 H15.3c-1.01,0-1.84-0.82-1.84-1.84c0-1.01,0.83-1.84,1.84-1.84h6.71C23.03,78.58,23.85,79.41,23.85,80.42z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167366980918135559620000005867816369320161175_",
    gradientUnits: "userSpaceOnUse",
    x1: -30.8321,
    y1: 27.5992,
    x2: 63.9047,
    y2: 109.5896
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167366980918135559620000005867816369320161175_)"
    },
    d: "M33.63,80.42c0,1.02-0.83,1.84-1.84,1.84 h-3.18c-1.01,0-1.83-0.82-1.83-1.84c0-1.01,0.82-1.84,1.83-1.84h3.18C32.8,78.58,33.63,79.41,33.63,80.42z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060000761425626764270000000854632117244216463_",
    gradientUnits: "userSpaceOnUse",
    x1: -20.6664,
    y1: 15.8531,
    x2: 74.0704,
    y2: 97.8435
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060000761425626764270000000854632117244216463_)"
    },
    d: "M70.96,80.42c0,1.02-0.82,1.84-1.83,1.84 H38.75c-1.01,0-1.83-0.82-1.83-1.84c0-1.01,0.82-1.84,1.83-1.84h30.38C70.14,78.58,70.96,79.41,70.96,80.42z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.d8068986f634c2d9fcefa8bb21b2e6b9.svg";
export { ForwardRef as ReactComponent };